import { AnyHighlightChildRequest, HighlightsContainerRequest, HighlightsSectionRequest } from '../model';
import { isHighlightsSection } from './model';

export const areSame = (
	a: AnyHighlightChildRequest,
	b: AnyHighlightChildRequest,
): boolean => (Boolean(a.id) && a.id === b.id) || (Boolean(a.newId) && a.newId === b.newId);

export function isEmptyHighlights(highlightsContainers: HighlightsContainerRequest[]): boolean {
	let isEmpty = true;

	highlightsContainers.forEach((container) => {
		if (container.sections.filter(isNonEmptySection).length > 0) {
			isEmpty = false;
		}
	});

	return isEmpty;
}

export function isNonEmptySection(section: HighlightsSectionRequest): boolean {
	return section.elements.length !== 0;
}

export const isEmptySection = (section: HighlightsSectionRequest): boolean => !isNonEmptySection(section);

export function findItemById(targetId: string, items: AnyHighlightChildRequest[]): AnyHighlightChildRequest | undefined {
	for (let i = 0; i < items.length; i++) {
		const curr = items[i];
		if (curr.id === targetId || curr.newId === targetId) {
			return curr;
		}
		if (isHighlightsSection(curr)) {
			const foundChild = findItemById(targetId, curr.elements);
			if (foundChild) {
				return foundChild;
			}
		}
	}
	return undefined;
}

export function hasAnyEmptySections(highlightsContainers: HighlightsContainerRequest[]): boolean {
	return highlightsContainers
		.flatMap(({ sections }) => sections)
		.some(isEmptySection);
}
